import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { getBrowserWidthBucket } from 'owa-layout';
import { ShouldForceFlexibleDayView } from '../constants';
import { getForcedFlexibleDayView } from './getForcedFlexibleDayView';

export function shouldForceFlexibleDayView() {
    const { dateRangeType } = getSurfaceStore();
    const availableWidthBucket = getBrowserWidthBucket();

    return (
        !getForcedFlexibleDayView() &&
        dateRangeType == DateRangeType.Week &&
        availableWidthBucket <= ShouldForceFlexibleDayView
    );
}

export function shouldRevertFlexibleDayView() {
    const availableWidthBucket = getBrowserWidthBucket();
    return getForcedFlexibleDayView() && availableWidthBucket > ShouldForceFlexibleDayView;
}
